














import Vue from 'vue'
import { Component } from 'vue-property-decorator'

@Component({})
export default class ConfirmDialogComponent extends Vue {
  dialog: boolean = false
  resolve: Function
  reject: Function
  message: string = ''
  title: string = ''
  options = {
    color: '',
    width: 320,
    zIndex: 200
  }

  open(title = '', message = '', options = {}) {
    this.dialog = true
    this.title = title
    this.message = message
    this.options = Object.assign(this.options, options)
    return new Promise((resolve, reject) => {
      this.resolve = resolve
      this.reject = reject
    })
  }

  agree() {
    this.resolve(true)
    this.dialog = false
  }

  cancel() {
    this.resolve(false)
    this.dialog = false
  }
}
